import img13a from '../../../assets/gallery/13b/13b-01-HOME_Si-vivimos-sera-una-revelacion-2013-200x300cm-oleo-sobre-papel.jpg';
import img13b from '../../../assets/gallery/13b/13b-02_ST-2013-200x300cm-oleo-sobre-papel.jpg';
import img13c from '../../../assets/gallery/13b/13b-03_ST-2013-200x300cm-oleo-sobre-papel.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img13a,
    description: "2013",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img13b,
    description: "2013",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img13c,
    description: "2013",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/13b/data13b.js